<template>
    <div class="mediasPage">
        <Header :code="code">{{this.projet.nom}}</Header>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" v-show="videos.length > 0">
                    <h4>Vidéos ({{videos.length}})</h4>
                </v-col>
                <v-col cols="12" class="video-item" v-if="videos.length > 0">
                    <video controls ref="video" :poster="currentVideo.thumb" :src="currentVideo.url"></video>
                    <div class="controls">
                        <v-btn @click="previousVideo" fab
                        dark
                        x-small
                        depressed
                        color="primary">
                            <v-icon dark>
                                mdi-chevron-left
                            </v-icon>
                        </v-btn>
                        <p>{{currentVideo.libelle}}</p>
                        <v-btn @click="nextVideo" fab
                        dark
                        x-small
                        depressed
                        color="primary">
                            <v-icon dark>
                                mdi-chevron-right
                            </v-icon>
                        </v-btn>
                    </div>
                </v-col>
                <v-col cols="12" v-if="audios.length > 0">
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="12" v-if="audios.length > 0">
                    <h4>Audios ({{audios.length}})</h4>
                </v-col>
                <v-col cols="12" v-if="audios.length > 0">
                    <vuetify-audio ref="audioPlayer" flat :file="currentAudio.url" color="primary" class="audioplayer"></vuetify-audio>
                    <div class="controls">
                        <v-btn @click="previousAudio" fab
                        dark
                        x-small
                        depressed
                        color="primary">
                            <v-icon dark>
                                mdi-chevron-left
                            </v-icon>
                        </v-btn>
                        <p>{{currentAudio.libelle}}</p>
                        <v-btn @click="nextAudio" fab
                        dark
                        x-small
                        depressed
                        color="primary">
                            <v-icon dark>
                                mdi-chevron-right
                            </v-icon>
                        </v-btn>
                    </div>
                </v-col>
                <v-col cols="12" v-if="documents.length > 0">
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="12" v-if="documents.length > 0">
                    <h4>Documents</h4>
                </v-col>
                <v-col cols="12" v-if="documents.length > 0">
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                <th class="text-left">
                                    Nom
                                </th>
                                <th class="text-center">
                                    Télécharger
                                </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                v-for="document in documents"
                                :key="document.libelle"
                                >
                                <td>{{ document.libelle }}</td>
                                <td class="text-center">
                                    <a :href="document.url+'?force_download'" download>
                                        <v-btn
                                        fab
                                        dark
                                        x-small
                                        depressed
                                        color="primary">
                                            <v-icon dark>
                                                mdi-download
                                            </v-icon>
                                        </v-btn>
                                    </a>
                                </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" v-if="images.length > 0">
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="12" v-if="images.length > 0">
                    <h4>Images</h4>
                </v-col>
                <v-col cols="6" v-for="image in images" :key="image.libelle">
                    <a class="image-item" :href="image.url+'?force_download'" download>
                        <img :src="image.thumb" alt="">
                        <v-btn
                            fab
                            dark
                            x-small
                            depressed
                            color="primary">
                                <v-icon dark>
                                    mdi-download
                                </v-icon>
                            </v-btn>
                    </a>
                </v-col>
                <v-col cols="12" v-if="!this.$store.state.medias" class="text-center">
                    <h4>Vous n'avez aucun médias de disponible</h4>
                </v-col>
            </v-row>
        </v-container>
        <Footer01 :code="this.code"/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Footer01 from '@/components/Footer01'
import axios from 'axios'
import VuetifyAudio from 'vuetify-audio'

export default {
    name: 'Medias',
    props: ['code'],
    components: {
        Header,
        Footer01,
        VuetifyAudio
    },
    data() {
        return {
            types : [],
            projet: {},
            videos: {},
            currentVideo: {},
            audios: {},
            currentAudio: {},
            documents: {},
            images: {}
        }
    },
    methods: {
        nextVideo(){
            let currentIndex = this.videos.findIndex((e) => e.libelle == this.currentVideo.libelle)
            let itemCount = this.videos.length;
            if(currentIndex + 1 == itemCount){
                this.currentVideo = this.videos[0]
            } else {
                this.currentVideo = this.videos[currentIndex + 1]
            }
        },
        previousVideo(){
            let currentIndex = this.videos.findIndex((e) => e.libelle == this.currentVideo.libelle)
            let itemCount = this.videos.length;
            if((currentIndex - 1) == -1){
                this.currentVideo = this.videos[itemCount - 1]
            } else {
                this.currentVideo = this.videos[currentIndex - 1]
            }            
        },
        nextAudio(){
            let currentIndex = this.audios.findIndex((e) => e.libelle == this.currentAudio.libelle)
            let itemCount = this.audios.length;
            if(currentIndex + 1 == itemCount){
                this.currentAudio = this.audios[0]
            } else {
                this.currentAudio = this.audios[currentIndex + 1]
            }
            this.$refs.audioPlayer.stop()
            this.$refs.audioPlayer.percentage = 0
        },
        previousAudio(){
            let currentIndex = this.audios.findIndex((e) => e.libelle == this.currentAudio.libelle)
            let itemCount = this.audios.length;
            if((currentIndex - 1) == -1){
                this.currentAudio = this.audios[itemCount - 1]
            } else {
                this.currentAudio = this.audios[currentIndex - 1]
            }
            this.$refs.audioPlayer.stop()
            this.$refs.audioPlayer.percentage = 0        
        },
    },
    computed: {
        
    },
    watch: {
        
    },
    created() {
         if(Object.keys(this.$store.state.leads).length === 0) {
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=> {
                    this.$store.dispatch('getMedias', {code_projet : this.code, id_utilisateur : this.$store.state.user.id}).then((e) => {
                        this.$store.dispatch('setLoader', false)
                        if(this.$store.state.medias){
                            this.documents = this.$store.state.medias.filter((e) => {
                                return e.type.indexOf('application') != -1
                            })
                            this.images = this.$store.state.medias.filter((e) => {
                                return e.type.indexOf('image') != -1
                            })
                            this.videos = this.$store.state.medias.filter((e) => {
                                return e.type.indexOf('video') != -1
                            })
                            this.currentVideo = this.videos[0];
                            this.audios = this.$store.state.medias.filter((e) => {
                                return e.type.indexOf('audio') != -1
                            })
                            this.currentAudio = this.audios[0];
                        }
                        if(this.$store.state.loader){
                            this.$store.dispatch('setLoader', false)
                        }
                        this.projet = this.$store.state.projets.find((e) => {
                            return e.code_projet == this.code
                        })
                    })
                })
            })
        } else {
            this.documents = this.$store.state.medias.filter((e) => {
                return e.type.indexOf('application') != -1
            })
            this.images = this.$store.state.medias.filter((e) => {
                return e.type.indexOf('image') != -1
            })
            this.videos = this.$store.state.medias.filter((e) => {
                return e.type.indexOf('video') != -1
            })
            this.currentVideo = this.videos[0];
            this.audios = this.$store.state.medias.filter((e) => {
                return e.type.indexOf('audio') != -1
            })
            this.currentAudio = this.audios[0];
            if(this.$store.state.loader){
                this.$store.dispatch('setLoader', false)
            }
            this.projet = this.$store.state.projets.find((e) => {
                return e.code_projet == this.code
            })
            console.log(this.projet);
        }
        
    },
}
</script>
<style lang="scss">
    .mediasPage {
        padding: 8vh 0;
        .typeText {
            display:flex;
            align-items:center;
            margin-bottom:20px;
        }
        .selector {
            margin-bottom:20px;
            .v-input {
                margin-top:0;
                padding-top:0;
            }
        }
        .video-item {
            video {
                width:100%;
            }
        }
        .image-item {
            position:relative;
            height: 100%;
            display: flex; 
            align-items:center;
            background-color:black;
            img  {
                width:100%;
                vertical-align: middle;
            }
            button {
                position:absolute;
                bottom:10px;
                right:10px;
            }
        }
        .controls {
            display:flex;
            justify-content: space-between;
            align-items:center;
            p {
                color: black;
                text-align:center;
                font-weight: bold;
                margin-bottom:0;
            }
        }
        .v-window__next, .v-window__prev {
                top: calc(100% - 26px);
           .v-btn--icon.v-size--default{
                height: 24px;
                width: 24px;
                .v-icon.v-icon {
                    font-size:24px !important;
                }
           }
        }
        .audioplayer{
            margin-bottom:5px;
             .v-card__text {
                 padding: 10px;
                 .v-btn {
                     margin: 0 10px !important;
                 }
                 p {
                     margin-bottom:0;
                 }
             }
        }
       
    }
</style>